<template>
  <v-container fluid>
    <h2>
      List of students<template v-if="status">: {{ status }}</template>
    </h2>
    <div class="pa-2" style="background-color: #e0f6ff77">
      <div class="py-4 d-flex justify-space-between">
        <v-text-field
          v-model="search"
          solo
          :loading="loading"
          dense
          clearable
          placeholder="Search"
          append-icon="mdi-magnify"
          style="max-width: 400px"
          @input="loading = true"
        />
        <v-btn color="#FF347C" class="white--text" @click="onCreate">
          Create Contact <v-icon>mdi-plus</v-icon>
        </v-btn>
      </div>
      <AppTable
        :key="status || 'all-students'"
        ref="table"
        :getter="computedGetter"
        :headers="headers"
      >
        <template #top>
          <v-container fluid>
            <v-row dense>
              <v-col cols="12" sm="6" md="4" lg="3">
                <v-text-field
                  v-model="filters.teacher__icontains"
                  outlined
                  hide-details
                  dense
                  label="Teacher"
                  clearable
                  append-icon="mdi-human-male-board"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <v-text-field
                  v-model="filters.program__icontains"
                  outlined
                  hide-details
                  dense
                  label="Program"
                  clearable
                  append-icon="mdi-format-list-bulleted-type"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <v-text-field
                  v-model="filters.marketing_source__icontains"
                  outlined
                  hide-details
                  dense
                  label="Marketing Source"
                  clearable
                  append-icon="mdi-comment-account-outline"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <v-text-field
                  v-model="filters.location__icontains"
                  label="Residence Country"
                  outlined
                  hide-details
                  dense
                  clearable
                  append-icon="mdi-flag"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3" class="ml-auto" @click="onFilter">
                <v-btn color="pink" block class="white--text">
                  Filter
                  <v-icon> mdi-magnify </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <template #item.status="{ item }">
          <span class="text-capitalize">{{ item.status.toLowerCase() }}</span>
        </template>
        <template #item.edit="{ item }">
          <div class="text-truncate">
            <ContactDetails :item="item" :key="'contact' + item.uuid" />
            <ActionButton color="#FF347C" icon="mdi-pencil" @click="onEdit(item)">
              Edit Contact
            </ActionButton>
            <StudentCrud :contact="item" :levels="levels" :key="'student' + item.uuid">
              <template #activator="{ on }">
                <ActionButton icon="mdi-account-plus" color="primary" v-on="on">
                  Create as student
                </ActionButton>
              </template>
            </StudentCrud>
            <DeleteContactButton :item="item" @item-deleted="onRefresh" :key="item.uuid" />
          </div>
        </template>
      </AppTable>
    </div>
    <ContactsCrudDialog v-model="dialogModel" :editedItem="editedItem" @new-item="onNew" />
  </v-container>
</template>
<script>
import AppTable from "../AppTable.vue";
import { tableHandler } from "@/compositions/tableHandler";
import { contactsController } from "@/api/crm";
import { getTeachers, getLevels } from "@/api/api";
import ActionButton from "./ActionButton.vue";
import ContactsCrudDialog from "./ContactsCrudDialog.vue";
import StudentCrud from "./StudentCrud.vue";
import { debounce } from "debounce";
import DeleteContactButton from "./DeleteContactButton.vue";
import ContactDetails from "./ContactDetails.vue";
import { ContactMethod, ContactedType, LevelingTest, SchoolType } from "@/api/crm";
import { ProgramItems } from "../../api/crm";
import { countries } from "../../utils/countries.constant";

export default {
  components: {
    AppTable,
    ActionButton,
    ContactsCrudDialog,
    StudentCrud,
    DeleteContactButton,
    ContactDetails,
  },
  props: {
    status: String,
  },
  setup: () => {
    return {
      ...tableHandler(contactsController),
    };
  },
  data() {
    return {
      countries,
      search: "",
      loading: false,
      teachers: [],
      filters: {
        leveling_test: "",
        marketing_source: "",
        contact_method: "",
        regsitered: undefined,
        contacted: undefined,
        contacted_type: "",
        school: "",
        service_agreement: undefined,
      },
      contactMethods: Object.entries(ContactMethod).map(([key, value]) => ({
        text: value,
        value: key,
      })),
      contactedType: Object.entries(ContactedType).map(([key, value]) => ({
        text: value,
        value: key,
      })),
      levelingTest: Object.entries(LevelingTest).map(([key, value]) => ({
        text: value,
        value: key,
      })),
      schoolItems: Object.entries(SchoolType).map(([key, value]) => ({
        text: value,
        value: key,
      })),
      booleanItems: [
        {
          text: "Yes",
          value: "true",
        },
        {
          text: "No",
          value: "false",
        },
      ],
      levels: [],
      programItems: ProgramItems,
    };
  },
  computed: {
    computedGetter() {
      return (params) => this.getter({ ...params, status: this.status });
    },
    headers() {
      const headers = [
        {
          text: "Full Name",
          value: "full_name",
        },
        {
          text: "Email",
          value: "email",
        },
        {
          text: "Phone",
          value: "phone",
        },
        {
          text: "Residence Country",
          value: "location",
        },
        {
          text: "Actions",
          value: "edit",
        },
      ];

      if (!this.status)
        headers.splice(1, 0, {
          text: "Status",
          value: "status",
        });

      return headers;
    },
  },
  watch: {
    search: debounce(function () {
      this.newFilter({ search: this.search, ...this.filters });
      this.loading = false;
    }, 500),
  },
  methods: {
    onFilter() {
      this.newFilter({ search: this.search, ...this.filters });
    },
  },
  mounted() {
    getTeachers({ limit: 100, is_active: "true" }).then(
      (response) => (this.teachers = response.data.results),
    );
    getLevels({ limit: 30 }).then((response) => {
      this.levels = response.data.results;
    });
  },
};
</script>
